<template>
  <div class="dashboard" >
    <v-layout row wrap py-3 class="my-5">
      <v-flex xs12 sm12 md12 v-for="ph in history" :key="ph.key" mb-1 px-5>
        <v-layout row wrap py-3 class="elevation-1" mb-1>
          <v-flex xs2 px-2>
            <div style="font-size:11px;font-weight:bold;">COUNTRY</div>
            <div>{{ph.country}}</div>
          </v-flex>
          <v-flex xs2 px-2>
            <div style="font-size:11px;font-weight:bold;">SKU</div>
            <div>{{ph.sku}}</div>
          </v-flex>
          <v-flex xs2 px-2>
            <div style="font-size:11px;font-weight:bold;">VENDOR</div>
            <div>{{ph.vendor}}</div>
          </v-flex>
          <v-flex xs2 px-2>
            <div style="font-size:11px;font-weight:bold;">PRICE</div>
            <div>{{ph.price}}</div>
          </v-flex>
          <v-flex xs2 px-2>
            <div style="font-size:11px;font-weight:bold;">DATE</div>
            <div>{{ph.date}}</div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {firebase, db, auth, store} from '@/fb'
import { titleCase, randomString } from '@/customFunction'
import axios from 'axios';
import json2csv from 'json2csv'

export default {
  data() {
    return {
      searchText:'',
      loading:false,
      history:[],
    }
  },
  props:{
    uid:{
      default:null
    }
  },
  methods:{
    goTo(path) {
      this.$router.push(path)
    },
		async getPriceHistory(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let a = await db.ref('pricehistory').once('value').then(x=>x.val())
        let history = []
        if(a) {
          let b = Object.keys(a)
          let c = Object.values(a)
          for (let i = 0; i < c.length; i++) {
            const it = c[i];
            console.log(it)
            if(it.history) {
              let h = Object.values(it.history).map(x=>{return {...x, sku:it.sku}})
              history.push(...h)
            }
          }
          console.log(this.history)
        }
        this.history = history
        this.loading = false
        res(true)
      })
    },
  },
  watch:{
    
  },
  created(){
    this.getPriceHistory()
  }
}
</script>

<style>

</style>
